import React, { PureComponent } from 'react'

export default class SectionLink extends PureComponent {
  onClick = () => {
    const el = document.getElementById(this.props.scrollTo)
    el && el.scrollIntoView()
  }

  render () {
    return (
      <div className="section-nav-item" onClick={this.onClick}>{this.props.name}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SectionLink.js